// $http is the fetch-based HTTP client, configured in HttpClientVuexPlugin
// Vue components access it via this.$store.$http
export const HttpClientPlugin = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$http', {
      get() {
        return this.$store?.$http;
      }
    });
  }
};
